// src/App.js
import React from "react";
import "./App.css"; // Tailwind and global styles
import "./index.css"
import ChildComponent from "./customerFacing/page.jsx"; // Import child component

export const metadata = {
  title: "Nuvia"
};

function App() {
  return (
    <div className="bg-background min-h-screen font-sans antialiased">
      {/* Your child component */}
      <ChildComponent /> {/* This will render the content from ChildComponent */}
    </div>
  );
}

export default App;
